module.exports = __webpack_public_path__ + "static/stage-background-ec915948335e933492bf17785d719818.mp4";